import React from 'react';
import { motion } from 'framer-motion';
import { Section, CHECKOUT_URL } from './Shared';
export const Pricing = () => {
  return <Section id="pricing" className="max-w-4xl" data-id="element-255" data-mp="2aqswvapoflqy">
      <div className="text-center mb-8 md:mb-10" data-id="element-256" data-mp="2oifubdvcv0bb">
        <h2 className="text-2xl md:text-4xl font-display font-bold uppercase tracking-[0.12em] text-brand-burgundy" data-id="element-257" data-mp="2oi7gnjrerqz2">
          Tu Mega Pack Chi Kung
        </h2>
        <p className="text-brand-textLight/80 mt-3 font-serif text-base md:text-lg italic" data-id="element-258" data-mp="1vticfbv235j3">
          El precio de lanzamiento cierra pronto. Después sube $25.000 ARS.
        </p>
      </div>

      <div className="max-w-md mx-auto" data-id="element-259" data-mp="25ry1786m22pf">
        <div className="rounded-2xl p-6 md:p-8 border border-brand-gold/40 bg-brand-purpleDark text-center flex flex-col relative shadow-2xl" data-id="element-260" data-mp="25tsr70wqol0d">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-burgundy text-brand-surface text-[10px] md:text-xs font-display font-semibold uppercase tracking-[0.2em] px-4 py-1 rounded-sm whitespace-nowrap shadow-md" data-id="element-261" data-mp="3h7ecgazha2gm">
            Oferta de lanzamiento
          </div>
          
          <h4 className="font-display font-semibold uppercase tracking-[0.2em] text-sm md:text-base text-brand-goldLight mb-2 mt-2" data-id="element-262" data-mp="4t5mxgphvg05">
            Mega Pack Chi Kung
          </h4>
          
          <div className="font-serif text-4xl md:text-5xl font-semibold text-brand-surface mb-2" data-id="element-263" data-mp="9qe6nlqajs3i">
            $24.990 ARS
          </div>
          <div className="text-[11px] md:text-xs text-brand-surfaceLight/40 line-through mb-4" data-id="element-264" data-mp="3d9qo4bbvx4sp">
            Precio regular: $95.000 ARS
          </div>
          
          <p className="text-sm md:text-base text-brand-surfaceLight/80 mb-7 flex-grow px-2 leading-relaxed" data-id="element-265" data-mp="3i5pfm7sif2xc">
            3 Tomos + 6 Bonus · Más de 190 páginas. El sistema integral de
            sesiones pre-diseñadas y blindaje para el terapeuta profesional.
          </p>
          
          <motion.a href={CHECKOUT_URL} whileTap={{
          scale: 0.99
        }} className="w-full inline-flex items-center justify-center px-6 py-4 font-display text-sm md:text-base font-semibold uppercase tracking-[0.18em] text-brand-surface bg-brand-burgundy hover:bg-brand-burgundyDark rounded-sm transition-colors duration-200 ease-out shadow-lg ring-1 ring-brand-burgundy/50 ring-offset-2 ring-offset-brand-purpleDark" data-id="element-266" data-mp="2ugd9xhwe5czs">
            Quiero mi Mega Pack $24.990
          </motion.a>
          
          <p className="text-center text-[10px] md:text-[11px] text-brand-surfaceLight/50 mt-5" data-id="element-267" data-mp="28hqrm7hz06n4">
            Garantía 7 días · Descarga inmediata · Pago seguro
          </p>
        </div>
      </div>
    </Section>;
};